import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

//Import Custom Component
import Breadcrumb from '../../../common/breadcrumb';

function PageError() {
  const crumbs = [
    {
      name: '404 — NIE ZNALEZIONO STRONY',
      path: `${process.env.PUBLIC_URL}/404`
    }
  ]

  return (
    <>
      <Helmet>
        <title>Strona nie została znaleziona - Buduj.pl</title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>

      <section className="error-header page-top">
        <Breadcrumb crumbs={ crumbs } addClass="mb-2" />
      </section>

      <div className="main">
        <div className="container">
          <section className="http-error">
            <div className="row justify-content-center py-3">
              <div className="col-md-7 text-center">
                <div className="http-error-main">
                  <h2>404<i className="fas fa-file ml-3"></i></h2>
                  <p>Przepraszamy, ale strona której szukasz nie istnieje.</p>
                </div>
              </div>

              <div className="col-md-4 mt-4 mt-md-0">
                <h4 className="text-primary">Oto kilka przydatnych linków</h4>
                <ul className="nav nav-list">
                  <li className="nav-item"><Link className="nav-link" to={ `${process.env.PUBLIC_URL}/` }>Strona główna</Link></li>
                  <li className="nav-item"><Link className="nav-link" to={ `${process.env.PUBLIC_URL}/pomoc-techniczna` }>Pomoc techniczna</Link></li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default PageError;